import { render, staticRenderFns } from "./SpecialistStatisticsAll.vue?vue&type=template&id=16af76b8&scoped=true&"
import script from "./SpecialistStatisticsAll.vue?vue&type=script&lang=js&"
export * from "./SpecialistStatisticsAll.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistStatisticsAll.vue?vue&type=style&index=0&id=16af76b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af76b8",
  null
  
)

export default component.exports